import apiRequestActionCreator from './apiRequestActionCreator';

export function fetchLocationInfoTitles({ excludeApmId }) {
    return apiRequestActionCreator({
        actionName: 'LOCATION_INFO_TITLES',
        actionParams: { excludeApmId },
        params: {
            url: `location-info-values/titles?excludeApmId=${excludeApmId}`,
        },
    });
}

export function fetchLocationInfoFields({ locationInfoTitle }) {
    return apiRequestActionCreator({
        actionName: 'LOCATION_INFO_FIELDS',
        actionParams: { locationInfoTitle },
        params: {
            url: `location-info-values/fields?locationInfoTitle=${locationInfoTitle}`,
        },
    });
}
